import { Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { Switch } from '@mui/material';
import { Controller } from 'react-hook-form';
import { MigrationModalProps } from '../migration/modal/MigrationModal';
import { wrapper } from './FreeTrial.css';

export const FreeTrial = ({
  control,
  freeTrial,
}: Pick<MigrationModalProps, 'control' | 'freeTrial'>) => {
  return (
    <div className={wrapper}>
      <Controller
        name={'monthlyFreeTrial'}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Row gap="l" alignCenter>
            <Switch
              checked={value}
              onChange={onChange}
              disabled={freeTrial.disabled.monthly}
              color="primary"
              slotProps={{
                input: {
                  name: 'monthly-free-trial',
                },
              }}
            />
            <Typography variant="body" size="large" fontWeight="normal">
              monthly subscription
            </Typography>
          </Row>
        )}
      />
      <Controller
        name={'annualFreeTrial'}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Row gap="l" alignCenter>
            <Switch
              checked={value}
              onChange={onChange}
              disabled={freeTrial.disabled.annual}
              color="primary"
              slotProps={{
                input: {
                  name: 'annual-free-trial',
                },
              }}
            />
            <Typography variant="body" size="large" fontWeight="normal">
              annual subscription
            </Typography>
          </Row>
        )}
      />
    </div>
  );
};
